import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Button, TextField, Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import PageTitle from '../../../shared/components/PageTitle';
import { Loader } from '../../../shared/components/Loader';
import { Formik } from 'formik';
import { useParams } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { addViewParticipants, getViewParticipantsListById } from '../../api';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    margin: {
        margin: theme.spacing(0),
    },
    withoutLabel: {
        marginTop: theme.spacing(0),
    },
    customToastProgress: {
        backgroundColor: '#F59300',
    },
}));

const UserWrapper = styled.div`
    position: relative;
    .css-sghohy-MuiButtonBase-root-MuiButton-root {
        background-color: #F59300 !important;
    }
    .css-1rwt2y5-MuiButtonBase-root-MuiButton-root {
        border : 1px solid #F59300 !important;
        color : #F59300 !important;
    }

    .wrapperWhite {
        background-color: #ffffff;
        padding: 1.5rem;
        border-radius: 18px;
    }

    .MuiTextField-root {
        width: 100%;
    }

    .card-box{
        position: relative;
        overflow: hidden;
        box-shadow: 0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12);
        border-radius: 0.5rem;
        color: rgba(0, 0, 0, 0.87);
        transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
        background-color: #fff;        
        cursor: pointer;
    }
    .card-indicator {
        position: absolute;
        height: 60%;
        top: 20%;
        width: 0px;
        border-top-right-radius: .75rem;
        border-bottom-right-radius: .75rem;
        left: 0;
        transition: all 0.3s linear;
    }
    .badge-primary {
        color: #fff;
        font-weight: 500;    
    }
    .roleName {
        font-size: 14px;
        font-weight: 500;
    }
    .roleItems { 
        width: 100%;
        height: 100%;
        position: absolute;
        opacity: 0;
        cursor: pointer;
    }
    .roleItems:checked ~ .card-indicator {
        width: 6px;
    }
    .customWidth : {
        width : 100% !important
    }
`;

export default function AddParticipant() {
    const classes = useStyles();
    const { id } = useParams();
    const { scheduleId } = useParams();
    const navigate = useNavigate();
    var [rows, setRows] = React.useState([]);
    var [userProfile, setUserProfile] = React.useState();
    var [userName, setUserName] = React.useState("");
    var [loading, setLoading] = React.useState(false);
    const addViewParticipantsMsg = () => toast("Participant Added Successfully!", { progressClassName: classes.customToastProgress });
    const updateViewParticipantsMsg = () => toast("Participant Updated Successfully!", { progressClassName: classes.customToastProgress });
    const errorMessage = () => toast("An error occured, try again later!", { progressClassName: classes.customToastProgress });

    useEffect(() => {
        userProfile = localStorage.getItem("userProfile");
        if (userProfile) {
            userProfile = JSON.parse(userProfile);
            setUserProfile(userProfile);
            userName = userProfile.userName;
            setUserName(userName);
        }

        fetchViewParticipantsListById();
    }, []);

    const fetchViewParticipantsListById = async () => {
        if (scheduleId) {
            setLoading(true);
            try {
                const res = await getViewParticipantsListById(scheduleId);
                if (res.data.successCode === 0) {
                    rows = res.data.data
                    setRows(rows);
                    console.log(rows);
                } else {
                    errorMessage();
                }
            } catch (error) {
                errorMessage();
            } finally {
                setLoading(false);
            }
        }
    }

    if (loading) {
        return (
            <div className="d-flex align-items-center vh-100 justify-content-center text-center font-weight-bold font-size-lg py-3">
                <Loader color="#ff9900" />
            </div>
        )
    }

    return (
        <Formik
            enableReinitialize={true}
            initialValues={{
                ParticipantName: rows?.participantName,
                Phone: rows?.phone,
                Company: rows?.company
            }}
            validate={values => {
                const errors = {};

                if (!values.ParticipantName) {
                    errors.ParticipantName = 'Required!';
                }
                if (!values.Phone) {
                    errors.Phone = 'Required!'
                }
                if (!values.Company) {
                    errors.Company = 'Required!';
                }

                return errors;
            }}

            const handleMouseDownPwd={(event) => {
                event.preventDefault();
            }}
            onSubmit={async (values, { setSubmitting, resetForm }) => {
                const postData = {
                    id: scheduleId ? scheduleId : 0,
                    trainingId: id,
                    participantName: values.ParticipantName,
                    phone: values.Phone,
                    Company: values.Company,
                    userName: userName || ""
                }
                try {
                    const res = await addViewParticipants(postData);
                    if (res.data.successCode === 0) {
                        { scheduleId ? updateViewParticipantsMsg() : addViewParticipantsMsg() }
                    } else {
                        errorMessage();
                    }
                    if (userProfile) {
                        setTimeout(() => { navigate("/schedule/training/" + id) }, 3000)
                    } else {
                        resetForm();
                    }
                } catch (error) {
                    errorMessage();
                    if (userProfile) {
                        setTimeout(() => { navigate("/schedule/training/" + id) }, 3000)
                    } else {
                        resetForm();
                    }
                }
                setSubmitting(false)
            }}
        >
            {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
            }) => (
                <form onSubmit={handleSubmit}>
                    <UserWrapper>
                        <ToastContainer theme='dark' />
                        <Grid container spacing={4} className='d-flex justify-content-center'>
                            <Grid item xs={12} sm={8} md={8} className="pt-3">
                                <PageTitle>Training Event</PageTitle>
                            </Grid>

                            <Grid item xs={12} sm={8} md={8} className="pt-3">
                                <TextField label="Name" variant="standard" name="ParticipantName" value={values.ParticipantName || ""} onChange={handleChange} onBlur={handleBlur} sx={{ width: 240 }} />
                                <div className="errMsg" style={{ marginTop: '5px' }}>{errors.ParticipantName && touched.ParticipantName && errors.ParticipantName}</div>
                            </Grid>
                            <Grid item xs={12} sm={8} md={8} className="pt-2">
                                <TextField label="Phone" variant="standard" name="Phone" value={values.Phone || ""} onChange={handleChange} onBlur={handleBlur} sx={{ width: 240 }} />
                                <div className="errMsg" style={{ marginTop: '5px' }}>{errors.Phone && touched.Phone && errors.Phone}</div>
                            </Grid>
                            <Grid item xs={12} sm={8} md={8} className="pt-2">
                                <TextField label="Company" variant="standard" name="Company" value={values.Company || ""} onChange={handleChange} onBlur={handleBlur} sx={{ width: 240 }} />
                                <div className="errMsg" style={{ marginTop: '5px' }}>{errors.Company && touched.Company && errors.Company}</div>
                            </Grid>
                            <Grid item xs={12} sm={8} md={8} className="text-right mt-4">
                                {userProfile && (
                                    <Button type="button" variant="outlined" color="primary" className="noShadow cancelBtn" onClick={() => navigate("/schedule")}>
                                        Cancel
                                    </Button>
                                )}&nbsp;&nbsp;
                                <Button type="submit" variant="contained" color="primary" className="noShadow addBtn" disabled={isSubmitting}>
                                    Submit
                                </Button>
                            </Grid>
                        </Grid>
                    </UserWrapper>
                </form>
            )}
        </Formik>
    );
}